import Highcharts from 'highcharts';
import HighchartsAccessibility from 'highcharts/modules/accessibility';

export default class ChartIRSituation {
  static exec() {
    const els = document.querySelectorAll('.highcharts-figure_ir-situation');
    els.forEach(function (el) {
      new ChartIRSituation(el);
    });
  }
  constructor(element) {
    const total = data.reduce((sum, item) => sum + item.y, 0);

    Highcharts.chart('container', {
      exporting: { enabled: false },
      credits: {
        enabled: false,
      },
      chart: {
        type: 'pie',
      },
      title: {
        text: '',
        style: {
          fontSize: '1.5em',
        },
      },
      tooltip: {
        valueSuffix: '%',
        pointFormat:
          '<span style="color:{point.color}">\u25CF</span>{series.name} <b>{point.percentage:.2f}%</b>',
      },
      subtitle: {
        text: '',
      },
      colors: [
        '#005bac',
        '#337CBD',
        '#669DCD',
        '#99BDDE',
        '#B3CEE6',
        '#CCDEEE',
      ],
      legend: {
        layout: 'horizontal',
        itemDistance: 50,
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                itemDistance: 10,
              },
              plotOptions: {
                series: {
                  dataLabels: [
                    {
                      enabled: false,
                      distance: 20,
                    },
                    {
                      enabled: true,
                      distance: -40,
                      format: '{point.percentage:.2f}%',
                      style: {
                        fontSize: '0.8em',
                        textOutline: 'none',
                        opacity: 0.7,
                      },
                      filter: {
                        operator: '>',
                        property: 'percentage',
                        value: 10,
                      },
                    },
                  ],
                },
              },
            },
          },
        ],
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          showInLegend: true,
          dataLabels: [
            {
              enabled: true,
              distance: 20,
            },
            {
              enabled: true,
              distance: -40,
              format: '{point.percentage:.2f}%',
              style: {
                fontSize: '1.2em',
                textOutline: 'none',
                opacity: 0.7,
              },
              filter: {
                operator: '>',
                property: 'percentage',
                value: 10,
              },
            },
          ],
        },
      },
      series: [
        {
          name: '',
          colorByPoint: true,
          data: data.map((item) => ({
            name: item.name,
            y: (item.y / total) * 100,
            percentage: (item.y / total) * 100,
          })),
        },
      ],
    });

    const detailsDiv = document.querySelector('.details table');
    data.forEach((item) => {
      const color =
        Highcharts.charts[0].series[0].data[data.indexOf(item)].color;
      const percentage = ((item.y / total) * 100).toFixed(2);

      item.y = item.y.toLocaleString();

      detailsDiv.innerHTML += `
        <tr>
            <th>
                <span class="details-dot" style="background-color: ${color};width: 16px;height: 16px;border-radius: 50%;flex-shrink: 0;"></span>
                ${item.name}
            </th>
            <td>${item.y}株</td>
            <td>${percentage}%</td>
        </tr>`;
    });
    detailsDiv.innerHTML += `
        <tr>
            <th>合計</th>
            <td>${total.toLocaleString()}株</td>
            <td>100.00%</td>
        </tr>`;
    document.querySelector('.total').textContent =
      total.toLocaleString() + '株';
  }
}
